export default __webpack_public_path__ + "static/taiwanGrateWindow-957a4450eb91ec69ba2448daba392ffc.svg";